import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const ServicePieChart = ({ data }) => {
  // Prepare data for the pie chart
  const chartData = Object.entries(data).map(([service, count], index) => ({
    name: service,
    value: count,
    fill: `hsl(${index * 90}, 70%, 55%)` // Better spaced colors
  }));

  const COLORS = chartData.map((_, index) => `hsl(${index * 90}, 70%, 55%)`);

  if (chartData.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 text-center">
        <p className="text-muted-foreground">No service data available</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 lg:p-6">
      <h3 className="text-lg font-heading font-semibold text-primary mb-4 text-center">
        Service Distribution
      </h3>

      {/* Chart Section */}
      <div className="h-56 sm:h-64 lg:h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
              // ✅ Labels only on larger screens
              label={({ name, percent }) =>
                window.innerWidth > 768
                  ? `${name} (${(percent * 100).toFixed(0)}%)`
                  : ''
              }
              labelLine={false}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`${value} bookings`, name]}
              contentStyle={{
                backgroundColor: 'var(--color-background)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* ✅ Mobile-friendly legend only */}
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {chartData.map((item, index) => (
          <div
            key={item.name}
            className="flex items-center justify-between bg-muted/30 rounded-xl px-3 py-2 shadow-sm"
          >
            <div className="flex items-center space-x-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              />
              <span className="font-medium text-sm">{item.name}</span>
            </div>
            <span className="text-sm text-muted-foreground">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicePieChart;
